<template>
    <div class="profile-information-section">
        <div class="profile-information-container">
            <div class="profile-section-header" :class="{ onSkills: active_main_tab == 'Skills' }">
                <div class="main-tab-section">
                    <div v-for="(tab, index) in main_tabs" :key="index" class="profile-info-tab"
                        :class="{ active: active_main_tab == tab.name }" @click="switchTab(tab)">
                        {{ tab.name }}
                    </div>
                </div>
                <div class="sub-tab-section" v-if="active_main_tab == 'Skills'">
                    <div v-for="(tab, index) in skills_tabs" :key="index" class="sub-info-tab"
                        :class="{ active: active_skill_tab == tab.name }" @click="switchSkillTab(tab)">
                        <div class="label">
                            {{ tab.name }}
                        </div>
                        <div class="tab-divider" v-if="skills_tabs.length - 1 > index"></div>
                    </div>
                </div>
            </div>
            <div class="profile-section-body" :class="{ onSkills: active_main_tab == 'Skills' }">
                <div v-if="active_main_tab == 'Projects'" class="profile-info--section">
                    <div class="profile-info-item" v-for="(item, index) in profile.projects" :key="index">
                        <div class="profile-info-item-option">
                            <input type="checkbox" v-model="item.checked">
                        </div>
                        <div class="profile-info-item-content">
                            <div class="profile-info-item-content-header">
                                <h2>{{ item.project_name }}</h2>
                            </div>
                            <div class="profile-info-item-content-body">
                                {{ item.project_start_date }}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="active_main_tab == 'Employments'" class="profile-info--section">
                    <div class="profile-info-item" v-for="(item, index) in profile.employments" :key="index">
                        <div class="profile-info-item-option">
                            <input type="checkbox" v-model="item.checked">
                        </div>
                        <div class="profile-info-item-content">
                            <div class="profile-info-item-content-header">
                                <h2>{{ item.employment_company }}</h2>
                            </div>
                            <div class="profile-info-item-content-body">
                                {{ item.employment_start_date }}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="active_main_tab == 'Educations'" class="profile-info--section">
                    <div class="profile-info-item" v-for="(item, index) in profile.educations" :key="index">
                        <div class="profile-info-item-option">
                            <input type="checkbox" v-model="item.checked">
                        </div>
                        <div class="profile-info-item-content">
                            <div class="profile-info-item-content-header">
                                <h2>{{ item.education_school }}</h2>
                            </div>
                            <div class="profile-info-item-content-body">
                                {{ item.education_start_date }}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="active_main_tab == 'Trainings'" class="profile-info--section">
                    <div class="profile-info-item" v-for="(item, index) in profile.trainings" :key="index">
                        <div class="profile-info-item-option">
                            <input type="checkbox" v-model="item.checked">
                        </div>
                        <div class="profile-info-item-content">
                            <div class="profile-info-item-content-header">
                                <h2>{{ item.training_certificate }}</h2>
                            </div>
                            <div class="profile-info-item-content-body">
                                {{ item.training_start_date }}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="active_main_tab == 'Certifications'" class="profile-info--section">
                    <div class="profile-info-item" v-for="(item, index) in profile.certifications" :key="index">
                        <div class="profile-info-item-option">
                            <input type="checkbox" v-model="item.checked">
                        </div>
                        <div class="profile-info-item-content">
                            <div class="profile-info-item-content-header">
                                <h2>{{ item.certification_name }}</h2>
                            </div>
                            <div class="profile-info-item-content-body">
                                {{ item.certification_date }}
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Skills -->
                <div v-if="active_main_tab == 'Skills' && active_skill_tab == 'Tools'" class="profile-info--section">
                    <div class="profile-info-item" v-for="(item, index) in profile.skillsObject.tools" :key="index">
                        <div class="profile-info-item-option">
                            <input type="checkbox" v-model="item.checked">
                        </div>
                        <div class="profile-info-item-content">
                            <div class="profile-info-item-content-header">
                                <h2>{{ item.name }}</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="active_main_tab == 'Skills' && active_skill_tab == 'Domains'" class="profile-info--section">
                    <div class="profile-info-item" v-for="(item, index) in profile.skillsObject.domains" :key="index">
                        <div class="profile-info-item-option">
                            <input type="checkbox" v-model="item.checked">
                        </div>
                        <div class="profile-info-item-content">
                            <div class="profile-info-item-content-header">
                                <h2>{{ item.name }}</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="active_main_tab == 'Skills' && active_skill_tab == 'Competences'" class="profile-info--section">
                    <div class="profile-info-item" v-for="(item, index) in profile.skillsObject.competences" :key="index">
                        <div class="profile-info-item-option">
                            <input type="checkbox" v-model="item.checked">
                        </div>
                        <div class="profile-info-item-content">
                            <div class="profile-info-item-content-header">
                                <h2>{{ item.name }}</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="active_main_tab == 'Skills' && active_skill_tab == 'Roles'" class="profile-info--section">
                    <div class="profile-info-item" v-for="(item, index) in profile.skillsObject.roles" :key="index">
                        <div class="profile-info-item-option">
                            <input type="checkbox" v-model="item.checked">
                        </div>
                        <div class="profile-info-item-content">
                            <div class="profile-info-item-content-header">
                                <h2>{{ item.name }}</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="active_main_tab == 'Skills' && active_skill_tab == 'Languages'" class="profile-info--section">
                    <div class="profile-info-item" v-for="(item, index) in profile.skillsObject.languages" :key="index">
                        <div class="profile-info-item-option">
                            <input type="checkbox" v-model="item.checked">
                        </div>
                        <div class="profile-info-item-content">
                            <div class="profile-info-item-content-header">
                                <h2>{{ item.name }}</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End of skills -->
            </div>
        </div>
        <div class="profile-info-options">
            <widgetButton :loading="false" @click="applySelected()" class="btn-secondary">
                Apply Selected
            </widgetButton>
        </div>
    </div>
</template>
<script>
import { SITE_API, ACCOUNT_TYPE } from "@/Store/variable.js";
import { eventBus } from "@/main";
export default {
    name: "profile-info",
    components: {
    },
    props: {
        template: {
            type: Array,
            default: () => {
                return []
            }
        },
        profileData: {
            type: Object,
            default: () => {
                return null;
            }
        }
    },
    data() {
        return {
            main_tabs: [
                {
                    name: "Projects",
                    active: true
                },
                {
                    name: "Employments",
                    active: false
                },
                {
                    name: "Skills",
                    active: false
                },
                {
                    name: "Educations",
                    active: false
                },
                {
                    name: "Trainings",
                    active: false
                },
                {
                    name: "Certifications",
                    active: false
                },
            ],
            active_main_tab: "Projects",
            skills_tabs: [
                {
                    name: "Tools",
                    active: true
                },
                {
                    name: "Domains",
                    active: true
                },
                {
                    name: "Competences",
                    active: true
                },
                {
                    name: "Roles",
                    active: true
                },
                {
                    name: "Languages",
                    active: true
                }
            ],
            active_skill_tab: "Tools",
            fullProfileData: {
                hasData: false,
                profile: {
                    profile_first_name: '',
                    profile_last_name: '',
                    profile_image: '',
                    profile_email: '',
                    profile_phone: '',
                    profile_address: '',
                    profile_description: '',
                },
                projects: [],
                employments: [],
                educations: [],
                trainings: [],
                certifications: [],
                skills: [],
                skillsObject: null
            },
            currentyProfileDataIndexing: {
                projects: 0,
                employments: 0,
                educations: 0,
                trainings: 0,
                certifications: 0,
                skills: 0
            },
            layers: null,
        };
    },
    computed: {
        profile() {
            let vm = this;
            let data = vm.profileData;
            data.projects = data.projects.map((item) => {
                // check if has key checked
                if (!item.hasOwnProperty('checked')) {
                    eventBus.$set(item, 'checked', false);
                }
                return item;
            });
            data.employments = data.employments.map((item) => {
                if (!item.hasOwnProperty('checked')) {
                    eventBus.$set(item, 'checked', false);
                }
                return item;
            });
            data.educations = data.educations.map((item) => {
                if (!item.hasOwnProperty('checked')) {
                    eventBus.$set(item, 'checked', false);
                }
                return item;
            });
            data.trainings = data.trainings.map((item) => {
                if (!item.hasOwnProperty('checked')) {
                    eventBus.$set(item, 'checked', false);
                }
                return item;
            });
            data.certifications = data.certifications.map((item) => {
                if (!item.hasOwnProperty('checked')) {
                    eventBus.$set(item, 'checked', false);
                }
                return item;
            });
            // Skills
            data.skillsObject.tools = data.skillsObject.tools.map((item) => {
                if (!item.hasOwnProperty('checked')) {
                    eventBus.$set(item, 'checked', false);
                }
                return item;
            });
            data.skillsObject.domains = data.skillsObject.domains.map((item) => {
                if (!item.hasOwnProperty('checked')) {
                    eventBus.$set(item, 'checked', false);
                }
                return item;
            });
            data.skillsObject.competences = data.skillsObject.competences.map((item) => {
                if (!item.hasOwnProperty('checked')) {
                    eventBus.$set(item, 'checked', false);
                }
                return item;
            });
            data.skillsObject.roles = data.skillsObject.roles.map((item) => {
                if (!item.hasOwnProperty('checked')) {
                    eventBus.$set(item, 'checked', false);
                }
                return item;
            });
            data.skillsObject.languages = data.skillsObject.languages.map((item) => {
                if (!item.hasOwnProperty('checked')) {
                    eventBus.$set(item, 'checked', false);
                }
                return item;
            });
            return data;
        }
    },
    watch: {},
    mounted() {
    },
    methods: {
        assignProfileDataOnPage(parent, children) {
            let vm = this;
            if (vm.fullProfileData.hasData) {
                let processedChildren = [];
                processedChildren = children.map((child) => {
                    if (child.itemType == 'text_element' && child.dataOriginOwner == 'profile' && child.dataOrigin) {
                        let profileText = vm.fullProfileData.profile[child.dataOrigin];
                        child.textValue = profileText;
                    }
                    if (child.itemType == 'image_element' && child.dataOriginOwner == 'profile' && child.dataOrigin) {
                        let fileName = vm.fullProfileData.profile[child.dataOrigin];
                        child.imageSrc = fileName ? SITE_API + "/super-manager/cvs/image/download?name=" + fileName : child.imageSrc
                    }

                    if (child.itemType == 'container_element') {
                        if (child.dataOrigin) {
                            // eslint-disable-next-line no-undef
                            let virtualChild = structuredClone(child);
                            let profileItemNumber = vm.fullProfileData[child.dataOrigin].filter(item => item.checked).length;
                            let profileItemData = new Array(profileItemNumber).fill(0);
                            profileItemData = profileItemData.map((item, index) => {
                                let data = vm.processProfileItem(child.dataOrigin, virtualChild, index);
                                data.itemId = 'item_' + vm.$makeId(20);
                                vm.currentyProfileDataIndexing[child.dataOrigin] += 1;
                                // eslint-disable-next-line no-undef
                                return structuredClone(data);
                            });
                            child['hasProfileContent'] = true;
                            child.children = profileItemData;
                            child.flexDirection = parent.flexDirection;
                            child.justifyContent = parent.justifyContent;
                            child.alignItems = parent.alignItems;
                            child.flexWrap = parent.flexWrap;
                            child.display = parent.display;
                        } else {
                            child['hasProfileContent'] = false;
                            child.children = vm.assignProfileDataOnPage(child, child.children);
                        }
                    }
                    return child;
                });
                return processedChildren;
            }
            return children;
        },
        processProfileItem(dataOriginOwner, child, i) {
            let vm = this;
            eventBus.$set(vm.fullProfileData[dataOriginOwner][vm.currentyProfileDataIndexing[dataOriginOwner]], 'checked', true);
            child.children = child.children.map((item) => {
                item.itemId = 'item_' + vm.$makeId(20);
                if (item.itemType == 'text_element' && item.dataOrigin) {
                    if (item.dataOrigin != 'project_skills' || item.dataOrigin != 'employment_skills') {
                        let profileText = vm.fullProfileData[dataOriginOwner][vm.currentyProfileDataIndexing[dataOriginOwner]][item.dataOrigin];
                        item.textValue = profileText;
                    }
                }
                else if (item.itemType == 'star_element' && item.dataOrigin) {
                    let profileSkillLevel = vm.fullProfileData[dataOriginOwner][vm.currentyProfileDataIndexing[dataOriginOwner]][item.dataOrigin];
                    item.numberOfItems = profileSkillLevel;
                }
                else if (item.itemType == 'container_element') {
                    return vm.processProfileItem(dataOriginOwner, item, i);
                }
                return item;
            });
            return child;
        },
        applySelected() {
            let vm = this;
            vm.fullProfileData.hasData = false;
            vm.currentyProfileDataIndexing = {
                projects: 0,
                employments: 0,
                educations: 0,
                trainings: 0,
                certifications: 0,
                skills: 0
            };
            vm.fullProfileData.profile.profile_first_name = vm.profile.profile.profile_first_name;
            vm.fullProfileData.profile.profile_last_name = vm.profile.profile.profile_last_name;
            vm.fullProfileData.profile.profile_email = vm.profile.profile.profile_email;
            vm.fullProfileData.profile.profile_image = vm.profile.profile.profile_image;
            if (vm.profile.profile) {
                vm.fullProfileData.profile.profile_phone = vm.profile.profile.profile_phone;
                vm.fullProfileData.profile.profile_address = vm.profile.profile.profile_address;
                vm.fullProfileData.profile.profile_description = vm.profile.profile.profile_description;
            }
            vm.fullProfileData.projects = vm.profile.projects.filter(item => {
                return item.checked;
            });
            vm.fullProfileData.employments = vm.profile.employments.filter(item => {
                return item.checked;
            });
            vm.fullProfileData.educations = vm.profile.educations.filter(item => {
                return item.checked;
            });
            vm.fullProfileData.trainings = vm.profile.trainings.filter(item => {
                return item.checked;
            });

            vm.fullProfileData.certifications = vm.profile.certifications.filter(item => {
                return item.checked;
            });
            let skillsArray = [];
            vm.profile.skillsObject.tools.forEach(item => skillsArray.push(item));
            vm.profile.skillsObject.domains.forEach(item => skillsArray.push(item));
            vm.profile.skillsObject.competences.forEach(item => skillsArray.push(item));
            vm.profile.skillsObject.roles.forEach(item => skillsArray.push(item));
            vm.profile.skillsObject.languages.forEach(item => skillsArray.push(item));
            vm.fullProfileData.skills = skillsArray.filter(item => {
                return item.checked;
            });
            vm.fullProfileData.skillsObject = null;
            vm.fullProfileData.hasData = true;

            //eslint-disable-next-line no-undef
            let layers = structuredClone(vm.template);
            vm.layers = layers.map((page) => {
                return {
                    ...page,
                    children: vm.assignProfileDataOnPage(page, page.children)
                };
            });

            vm.$nextTick(() => {
                vm.$emit("editAppliedCv", { layers: vm.layers, template: vm.template, profile: vm.profileData });
            });


        },
        switchSkillTab(tab) {
            let vm = this;
            vm.active_skill_tab = tab.name;
        },
        switchTab(tab) {
            let vm = this;
            vm.active_main_tab = tab.name;
        }
    },
};
</script>
  
<style lang="scss" scoped>
$assets: "~@/assets";

.profile-information-section {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 5px;

    .profile-information-container {
        background: #F5F5F5;
        border-radius: 5px;
        width: 100%;
        height: calc(100% - 50px);
        display: flex;
        flex-direction: column;

        .profile-section-header {
            height: 50px;
            display: flex;
            flex-direction: column;
            padding: 0px 5px;
            margin-bottom: 8px;



            .main-tab-section {
                display: flex;
                width: 100%;
                height: 100%;
                padding-left: 5px;
                padding-right: 5px;
                overflow-x: auto;
                align-items: center;

                .profile-info-tab {
                    padding: 5px 10px;
                    border-radius: 5px;
                    margin-right: 5px;
                    cursor: pointer;

                    &:hover {
                        color: #0884AF;
                    }

                    &.active {
                        color: #0884AF;
                    }

                }
            }

            &.onSkills {
                height: 80px;

                .main-tab-section {
                    height: 50%;
                }
            }

            .sub-tab-section {
                display: flex;
                width: 100%;
                height: 50%;
                padding-left: 10px;
                padding-right: 10px;
                overflow-x: auto;
                align-items: center;
                background-color: #fff;
                border: 1px solid #E4E4E4;
                border-radius: 5px;

                .sub-info-tab {
                    padding: 8px 0px;
                    border-radius: 5px;
                    margin-right: 5px;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    cursor: pointer;

                    .label {
                        font-size: 12px;
                        font-weight: 500;
                        margin-right: 5px;
                    }

                    .tab-divider {
                        width: 1px;
                        height: 100%;
                        background-color: #E6E6E6;
                        margin: 0px 8px;
                    }

                    &:hover {
                        .label {
                            color: #0884AF;
                        }
                    }

                    &.active {
                        color: #0884AF;
                    }
                }
            }
        }

        .profile-section-body {
            padding: 0px 5px;
            opacity: 1;
            transition: 3000ms ease-in-out;
            display: flex;
            flex-direction: column;
            height: calc(100% - 50px);
            overflow-y: auto;

            &.onSkills {
                height: calc(100% - 80px);
            }

            .profile-info-item {
                display: flex;
                padding: 6px 6px;
                background-color: #fff;
                border-radius: 5px;
                margin-bottom: 10px;

                .profile-info-item-option {
                    width: 30px;
                }

                .profile-info-item-content {
                    display: flex;
                    flex-direction: column;
                    width: calc(100% - 30px);

                    .profile-info-item-content-header {
                        h2 {
                            margin: 0px;
                            font-size: 14px;
                        }
                    }
                }
            }

        }
    }

    .profile-info-options {
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>